import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { UserApi } from '@shared-features/services';
import { UserRoleService } from '@shared/services';


@Injectable({
  providedIn: 'root'
})
export class NoAuthGuard implements CanActivate, CanActivateChild {
  private userApi = inject(UserApi);
  private router = inject(Router);
  private userRoleService = inject(UserRoleService);


  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.checkAccessGrant(childRoute, state);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.checkAccessGrant(route, state);
  }


  private checkAccessGrant(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const isLoggedIn = this.userApi.isLoggedIn();
    if (isLoggedIn) {
      this.router.navigateByUrl(this.userRoleService.landingRoute());
      return false;
    } else {
      return true;
    }
  }

}
